import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { authUploadPage } from '../../actions/UploadPages';

import UploadPageHeader from './Header';
import UploadPageTitle from './Title';
import ProcessingSpinner from '../ProcessingSpinner';

import { isValidEmail } from '../../helpers/Validators';

const UploadPageUnlockAccess = (({
  uploadPage,
  performAuth,
}) => {
  const intl = useIntl();

  const [form, setForm] = useState({
    password: '',
    email: '',
    name: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const vErrors = {};

    if (uploadPage.require_password && form.password.trim() === '') {
      vErrors.password = intl.formatMessage({ defaultMessage: 'Password is incorrect' });
    }

    if (uploadPage.require_email && !isValidEmail(form.email.trim())) {
      vErrors.email = intl.formatMessage({ defaultMessage: 'Enter a valid email address' });
    }

    if (uploadPage.require_name && form.name.trim() === '') {
      vErrors.name = intl.formatMessage({ defaultMessage: 'Enter your name' });
    }

    setErrors(vErrors);

    return Object.keys(vErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});
    performAuth(uploadPage.uuid, form).then((response) => {
      const { data } = response;
      if (data.errors) {
        setErrors(data.errors);
        setLoading(false);
      }
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    setForm({ ...form, [name]: value });
  };

  let icon = '';
  if (uploadPage.require_password) {
    icon = 'lock';
  }
  if (
    uploadPage.require_email ||
    uploadPage.require_name
  ) {
    if (uploadPage.require_password) {
      icon = 'user-lock';
    } else {
      icon = 'user';
    }
  }

  const fields = [];
  if (uploadPage.require_name) {
    fields.push(intl.formatMessage({
      defaultMessage: 'name',
    }));
  }
  if (uploadPage.require_email) {
    fields.push(intl.formatMessage({
      defaultMessage: 'email',
    }));
  }
  if (uploadPage.require_password) {
    fields.push(intl.formatMessage({
      defaultMessage: 'password',
    }));
  }

  const text = intl.formatMessage({
    defaultMessage: `{fieldsCount, select,
      1 {Enter your {field1} to access this guest upload page}
      2 {Enter your {field1} and {field2} to access this guest upload page}
      3 {Enter your {field1}, {field2} and {field3} to access this guest upload page}
      other {Enter your details to access this guest upload page}}`,
  }, {
    fieldsCount: fields.length,
    field1: fields[0],
    field2: fields[1],
    field3: fields[2],
  });

  return (
    <div className="upload-main">
      <UploadPageHeader />
      <div className="upload-content">
        <UploadPageTitle />
        <div className="lock-section">
          <div className="lock-wrapper">
            <i className={`fa-regular fa-${icon}`} />
          </div>
          <h2>{text}</h2>
          <Form onChange={handleChange} onKeyPress={handleKeyPress}>
            <div className="access-input-container">
              {uploadPage.require_name && (
                <div>
                  <Input
                    name="name"
                    id="inpName"
                    placeholder={intl.formatMessage({ defaultMessage: 'Enter your name' })}
                    invalid={!!errors.name}
                  />
                  <FormFeedback>
                    {errors.name}
                  </FormFeedback>
                </div>
              )}
              {uploadPage.require_email && (
                <div>
                  <Input
                    type="email"
                    name="email"
                    id="inpEmail"
                    placeholder={intl.formatMessage({ defaultMessage: 'Enter your email' })}
                    invalid={!!errors.email}
                  />
                  <FormFeedback>
                    {errors.email}
                  </FormFeedback>
                </div>
              )}
              {uploadPage.require_password && (
                <div>
                  <Input
                    type="password"
                    name="password"
                    id="inpPassword"
                    placeholder={intl.formatMessage({ defaultMessage: 'Enter your password' })}
                    invalid={!!errors.password}
                  />
                  <FormFeedback>
                    {errors.password}
                  </FormFeedback>
                </div>
              )}
              <div className="submit-wrapper">
                <Button
                  color="primary"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  <ProcessingSpinner show={loading} /> {intl.formatMessage({ defaultMessage: 'Submit' })}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
});

const mapStateToProps = state => ({
  uploadPage: state.UploadPages.uploadPage,
});

const mapDispatchToProps = dispatch => ({
  performAuth: (uploadPageUuid, params) => (
    dispatch(authUploadPage(uploadPageUuid, params))
  ),
});

UploadPageUnlockAccess.propTypes = {
  uploadPage: PropTypes.object.isRequired,
  performAuth: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadPageUnlockAccess);
